/* EVERLYGO theme JS — slider, sticky header, reveals, mobile menu */
(function () {
  "use strict";

  /* Sticky header state */
  var header = document.querySelector("[data-header]");
  if (header) {
    var onScroll = function () {
      header.classList.toggle("scrolled", window.scrollY > 32);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  /* Mobile menu */
  var toggle = document.querySelector("[data-menu-toggle]");
  var menu = document.querySelector("[data-mobile-menu]");
  if (toggle && menu) {
    toggle.addEventListener("click", function () {
      var open = menu.classList.toggle("open");
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
      document.body.style.overflow = open ? "hidden" : "";
    });
    menu.querySelectorAll("a").forEach(function (a) {
      a.addEventListener("click", function () {
        menu.classList.remove("open");
        document.body.style.overflow = "";
      });
    });
  }

  /* Scroll reveals */
  var revealObserver = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("in");
          revealObserver.unobserve(entry.target);
        }
      });
    },
    { rootMargin: "0px 0px -60px 0px", threshold: 0.05 }
  );
  document.querySelectorAll(".rv").forEach(function (el) {
    revealObserver.observe(el);
  });

  /* Hero slider */
  document.querySelectorAll("[data-hero]").forEach(function (hero) {
    var slides = hero.querySelectorAll("[data-slide]");
    var counter = hero.querySelector("[data-counter]");
    if (slides.length < 2) {
      if (slides.length === 1) slides[0].classList.add("active");
      return;
    }
    var index = 0;
    var timer = null;
    var pad = function (n) {
      return String(n).padStart(2, "0");
    };
    var show = function (i) {
      index = (i + slides.length) % slides.length;
      slides.forEach(function (s, k) {
        s.classList.toggle("active", k === index);
      });
      if (counter) counter.textContent = pad(index + 1) + " — " + pad(slides.length);
    };
    var restart = function () {
      if (timer) clearInterval(timer);
      timer = setInterval(function () {
        show(index + 1);
      }, 7000);
    };
    hero.querySelectorAll("[data-prev]").forEach(function (b) {
      b.addEventListener("click", function () {
        show(index - 1);
        restart();
      });
    });
    hero.querySelectorAll("[data-next]").forEach(function (b) {
      b.addEventListener("click", function () {
        show(index + 1);
        restart();
      });
    });
    show(0);
    restart();
  });

  /* Story / play control placeholder */
  document.querySelectorAll("[data-story-control]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var msg = btn.getAttribute("data-story-message") || "Our story film is in production — coming soon.";
      var note = document.createElement("div");
      note.textContent = msg;
      note.style.cssText =
        "position:fixed;left:50%;top:24px;transform:translateX(-50%);z-index:100;" +
        "background:#14231C;color:#FBF9F5;padding:14px 28px;border-radius:999px;" +
        "font:500 14px Switzer,sans-serif;box-shadow:0 20px 48px rgba(20,35,28,0.25);";
      document.body.appendChild(note);
      setTimeout(function () {
        note.style.transition = "opacity 0.4s";
        note.style.opacity = "0";
        setTimeout(function () {
          note.remove();
        }, 400);
      }, 2600);
    });
  });
})();
